







































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
/* component */
import PageTitle from '@/app/components/Common/PageTitle.vue'
import Local from '@/app/module/local'
import CommonClass from '@/app/module/common'
import { userType } from '@/app/model/store/domain/const'

@Component({
  components: {
    PageTitle
  }
})
export default class ExternalLinkSearch extends Vue {
  private year: number = this.$store.state.externalLinkState.selectedYear
  private search: string = this.$store.state.externalLinkState.searchText
  private yearList: number[] = []
  private externalLinkTitle: string = ''
  private externalLinkSearchPlaceHolder: string = ''
  private isAdmin: boolean = false

  @Prop() private externalLinkCount!: number
  @Prop() private externalLinkContentCount!: number

  created () {
    this.externalLinkTitle = CommonClass.getServiceFunctionData().external_link.external_link_name
    this.externalLinkSearchPlaceHolder = this.externalLinkTitle + '名、品種、地区、タイトルで検索'

    if (Local.getUserType() === String(userType.USER_TYPE_ADMIN)) {
      this.isAdmin = true
    }

    /* yearの配列を作成 */
    const endYear = new Date().getFullYear() + 1
    const constantValue = JSON.parse(Local.getConstantValue()!)
    let minPlantYear = constantValue.min_plant_year
    if (minPlantYear === null) {
      minPlantYear = new Date().getFullYear()
    }
    for (let i = minPlantYear; i <= endYear; i++) {
      this.yearList.unshift(i)
    }
    if (this.$store.state.externalLinkState.selectedYear === 0) {
      this.year = new Date().getFullYear()
    } else {
      this.year = this.$store.state.externalLinkState.selectedYear
    }
  }

  private doSearch () {
    this.$store.commit('externalLinkState/setSearchText', this.search)
    this.$store.commit('externalLinkState/setSelectedYear', this.year)
    this.$emit('search-list')
  }

  private doClear () {
    this.search = ''
    this.year = new Date().getFullYear()
    this.$store.commit('externalLinkState/setSearchText', this.search)
    this.$store.commit('externalLinkState/setSelectedYear', this.year)
    this.$emit('search-list')
  }
}
